export function Clusters() {
  return (
    <div>
      <p className="text-gray-600 dark:text-gray-400">Monitor and manage OpenShift clusters.</p>
    </div>
  );
}


